import styled from 'styled-components'

export const Container = styled.div`
  display: grid;
  gap: 24px;
`

export const Bold = styled.span`
  font-weight: 600;
`
